import $ from 'jquery';
import { initMap } from './components/openlayers-map-draw-locators.js';

// more button
let actualPage = 0;
$('#moreBtn').on('click', function () {
    actualPage++;
    $('.show-group-' + actualPage).show();
    if ($('.show-group-' + (actualPage + 1)).length === 0) {
        $(this).hide();
    }
});

initMap();
